import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { resellerQueryOptions } from '@/core/components/resellers/resellerQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const resellersSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'name',
      'image',
      'id',
      'fee',
      'completedStays',
      'revenueOnCompletedStays',
      'invoiceRevenue',
      'sitesCreated',
    ])
    .catch('completedStays'),
  orderBy: z.enum(['asc', 'desc']).catch('asc'),
})

export const Route = createFileRoute('/_layout/dashboard/resellers/')({
  validateSearch: (search) => resellersSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role !== Role['Internal']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    queryClient.ensureQueryData(resellerQueryOptions(auth.token as string))
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
